<div class="pdf-page app-aul-013-24" id="washington1324">
  <!-- <app-policy-header></app-policy-header> -->
  <br />
  <p class="font-large" style="text-align: center">
    <b>AMENDATORY ENDORSEMENT</b>
  </p>
  <p class="font-large" style="text-align: center"><b>WASHINGTON CHANGES</b></p>
  <p class="font-large" style="text-align: center">
    <b>THIS ENDORSEMENT CHANGES THE POLICY. PLEASE READ CAREFULLY</b>
  </p>
  <p class="font-medium">
    <b>
      This endorsement comprising of policyholder notices, coverage changes and
      endorsements attaches to and forms part of the policy numbered
      {{ this.policyDetails?.policyNo }}
    </b>
  </p>
  <br />
  <p class="font-medium" style="text-decoration: underline">
    <b><u>SURPLUS LINES DISCLOSURE NOTICE</u></b>
  </p>
  <p class="font-medium" style="text-align: justify; width: 95%;">
    <b>
      THIS CONTRACT IS REGISTERED AND DELIVERED AS A SURPLUS LINE COVERAGE UNDER
      THE INSURANCE CODE OF THE STATE OF WASHINGTON, TITLE 48 RCW. IT IS NOT
      PROTECTED BY ANY WASHINGTON STATE GUARANTY ASSOCIATION LAW.
    </b>
  </p>
  <div>
    <div>
      <p class="font-medium">
        <b
          ><span style="text-decoration: underline"
            >SERVICE OF SUIT CLAUSE</span
          ></b
        >
      </p>
    </div>
    <div>
      <p class="font-medium">
        <u>FORTEGRA SPECIALTY INSURANCE COMPANY</u>
      </p>
      <p class="font-medium">
        It is understood and agreed that in the event of the failure of the
        Company to pay any amount claimed to be due hereunder, the Company, at
        the request of the Named Insured, will submit to the jurisdiction of a
        court of competent jurisdiction within the United States of America. The
        foregoing shall not constitute a waiver of the right of the Company to
        remove, remand or transfer such suit to any other court of competent
        jurisdiction in accordance with the applicable statutes of the state or
        United States pertinent hereto. In any suit instituted against them upon
        this contract, the Company will abide by the final decision of such
        court or of any appellate court in the event of an appeal.
      </p>
      <p class="font-medium">
        It is further agreed that service of process in such suit may be made
        upon the Superintendent, Commissioner, or Director of Insurance or other
        person specified for that purpose in the statute or his successor or
        successors in office as their true and lawful attorney upon whom may be
        served any lawful process in any action, suit, or proceeding instituted
        by or on behalf of the Named Insured or any beneficiary hereunder
        arising out of this contract of insurance.
      </p>
      <p class="font-medium">
        The Company hereby designates as the person to whom the said
        Superintendent, Commissioner, or Director of Insurance is authorized to
        mail such process or a true copy thereof, in compliance with the
        applicable statutes governing said service of process in the state or
        jurisdiction in which a cause of action under this contract of insurance
        arises.
      </p>
      <p class="font-medium">
        <b>Corporate Creations Network Inc. </b><br>  
        <b>707 W. Main Avenue #B1</b><br>     
        <b>Spokane, WA 99201 </b> <br>     
        <b>Spokane County</b> <br>    
        <b>Phone: (561) 694-8107</b><br>
      </p>
    </div>
    <p class="font-small">
      ALL OTHER TERMS, CONDITIONS, PROVISIONS AND EXCLUSIONS OF THIS POLICY
      REMAIN THE SAME.
    </p>
    <p class="font-small">FSIC WA SOS 01 25</p>
  </div>
</div>
